//******************************************************************************
// プロトコルgsidem
// gsiのdem（数値標高PNGタイル）をmapboxのterrainRGB形式に変換するためのプロトコル
//******************************************************************************

// 将来的にはFileFetcherを導入した大幅改造が必要だが2026-02-25時点では見送り
// import { FileFetcher } from 'file-fetcher';
// const fetcher = new FileFetcher();
// またタイルサイズ固定、png固定である部分も修正が必要
// 外部から内部オブジェクトへ値を渡す処理を実装する必要あり


import { FileFetcher } from "file-fetcher";
const fetcher = new FileFetcher();


//------------------------------------------------------------------------------
// 数値RGBA変換関数
const valueToRgba = (value) => {
	return [
		value >> 16 & 0xff,
		value >> 8 & 0xff,
		value & 0xff,
		255
	];
};

//------------------------------------------------------------------------------
// DEM変換プロトコル用関数
const gsiToTerrainRgba = (rgba) => {
	// メートル換算で標高値を決める（標高PNGタイルはセンチメートル単位）
	const height = (
		(
			((rgba[0] === 128 && rgba[1] === 0 && rgba[2] === 0) || rgba[3] === 0)
				? 0
				: rgba[0] * 65536 + rgba[1] * 256 + rgba[2] - (rgba[0] < 128 ? 0 : 16777216)
		) * 0.01
	);
	// Terrain-RGBのオフセット10000メートルを加算してTerrain-RGBのデシメートル単位に変換
	// https://docs.mapbox.com/data/tilesets/reference/mapbox-terrain-rgb-v1/
	// return valueToRgba( Math.floor(( height + 10000 ) * 10 ));
	// Terrain-RGBは水深10000メートルより深い値を表現できないので-10000で丸める
	// return valueToRgba( Math.floor((( height < -10000 ? -10000 : height ) + 10000 ) * 10 ));
	return valueToRgba(Math.floor((Math.max(-10000, height) + 10000) * 10));
};


const tileSize = 256;
const rgbaZero = [1, 134, 160, 255];
const typed = new Uint8ClampedArray((tileSize ** 2) * 4);
for (let i = 0, j = typed.length; i < j; i += 4) {
	typed.set(rgbaZero, i);
}
const imageData = new ImageData(typed, tileSize);
const zeroImageBitmap = createImageBitmap(imageData);


//------------------------------------------------------------------------------
// プロトコル関数
// const gsidemToTerrainRgb = async (params, abortController) => {
// 	return await new Promise((resolve) => {
// 		//----------------------------------------------------------------------
// 		const image = new Image();
// 		image.crossOrigin = 'anonymous';
// 		//----------------------------------------------------------------------
// 		const canvas = document.createElement('canvas');
// 		canvas.width = 256;
// 		canvas.height = 256;
// 		const context = canvas.getContext('2d');
// 		//----------------------------------------------------------------------
// 		image.addEventListener('load', (event) => {
// 			context.drawImage(event.target, 0, 0);
// 			const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
// 			for (let i = 0; i < imageData.data.length / 4; i++) {
// 				const index = i * 4;
// 				const rgba = gsiToTerrainRgba(
// 					imageData.data.subarray(index, index + 4)
// 				);
// 				imageData.data.set(rgba, index);
// 			}
// 			context.putImageData(imageData, 0, 0);
// 			canvas.toBlob(async (blob) => {
// 				const arraybuffer = await blob.arrayBuffer();
// 				resolve({ data: arraybuffer });
// 			});
// 		});
// 		//----------------------------------------------------------------------
// 		image.addEventListener('error', (event) => {
// 			// terrainRGBの標高0の値を決める
// 			// オフセット100000デシメートル（10000メートル）
// 			context.fillStyle = 'rgb(1,134,160)';
// 			context.fillRect(0, 0, canvas.width, canvas.height);
// 			canvas.toBlob(async (blob) => {
// 				const arraybuffer = await blob.arrayBuffer();
// 				resolve({ data: arraybuffer });
// 			});
// 		});
// 		//----------------------------------------------------------------------
// 		image.src = params.url.substring(('gsidem://').length);
// 	});
// };

const gsidemToTerrainRgb = async (params, abortController) => {
	try {
		const imageData = await fetcher.getImageData(
			params.url.substring(('gsidem://').length)
		);
		for (let i = 0, j = imageData.data.length; i < j; i += 4) {
			const rgba = gsiToTerrainRgba(
				imageData.data.subarray(i, i + 4)
			);
			imageData.data.set(rgba, i);
		}
		const bitmap = await createImageBitmap(imageData);
		return { data: bitmap };
	} catch (error) {
		return { data: zeroImageBitmap };
	}
};

//------------------------------------------------------------------------------
// export
export default gsidemToTerrainRgb;
